import { render, staticRenderFns } from "./NotificationsComponent.vue?vue&type=template&id=95c08e0a&scoped=true"
import script from "./NotificationsComponent.vue?vue&type=script&lang=js"
export * from "./NotificationsComponent.vue?vue&type=script&lang=js"
import style0 from "./NotificationsComponent.vue?vue&type=style&index=0&id=95c08e0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c08e0a",
  null
  
)

export default component.exports